// ======================================================================
// File Name       : UserHistoryStudentDetailTitle
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, InputGroup, Button } from 'react-bootstrap';
import RenderField from '../../../utils/ReduxFormUtils';
import {
  convertNodeGroupToNodeString,
  convertObjectToList,
  convertUserIdToUserName,
  convertGroupListIdToGroupName,
} from '../../../utils/UserUtils';

import PaginationCustom from '../../Pagination';
import CustomButton from '../../button/CustomButton';

class UserHistoryStudentDetailTitle extends React.Component {
  render() {
    const {
      groupList,
      userList,
      groupRelationList,
      userSecernId,
      onExportFileCSV,
      isViewingResult,
    } = this.props;
    const groupListByUser = convertObjectToList(groupRelationList, 'userSecernId', 'groupSecernId');
    const userName = convertUserIdToUserName(userSecernId, userList);
    let groupName = null;
    if (groupListByUser && groupListByUser[userSecernId]) {
      const groupSecernIdList = groupListByUser[userSecernId].groupSecernId;
      groupName = convertGroupListIdToGroupName(groupSecernIdList, groupList);
    }
    return (
      <div>
        <Col sm={12}>
          <Form className='form-horizontal'>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                ユーザー名
              </Col>
              <Col as={Form.Label} sm={5}>
                {userName}
              </Col>
              {!isViewingResult && (
                <Col sm={4} className='padding-right-15'>
                  <CustomButton
                    btnStyle="btn btn-primary btn-96 float-end"
                    handleClick={onExportFileCSV}
                    text="全コース一括出力"
                    iconClass="bi bi-download"
                  />
                </Col>
              )}
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                ユーザーグループ名
              </Col>
              <Col as={Form.Label} sm={7}>
                {groupName}
              </Col>
            </Form.Group>
          </Form>
        </Col>
      </div>
    );
  }
}

export default UserHistoryStudentDetailTitle;
